import { Component, Inject } from '@angular/core'
import {
  BasePanelComponent,
  LayoutContainer,
  PanelCategory,
  PanelConfig,
} from '@helios/panel-base'
import { ComponentContainer } from 'golden-layout'

@Component({
  selector: 'hs-not-found',
  template: `
    <div>
      <i class="mdi mdi-information text-white"></i>
    </div>
    <div class="info">
      <h4>Panel Not Available</h4>
      <p>
        We were unable to load the {{ title }} Panel because it is not available
        to you. To request access to this panel, please contact your Sales or
        Client Services representative.
      </p>
    </div>
  `,
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent extends BasePanelComponent {
  title = ''
  constructor(@Inject(LayoutContainer) container: ComponentContainer) {
    super(container)
  }
}
/*
  NotFoundComponent is only shown when a user has a panel in their workspace that either:
   1. Has been deleted from Helios codebase
   2. User no longer has access to the panel being displayed
*/
export const NotFoundComponentConfig: PanelConfig = {
  key: 'panel-not-found',
  title: 'Not Found',
  description: '',
  category: PanelCategory.HELP,
  panelComponent: NotFoundComponent,
  accessPermission: undefined,
  hasAccess: true, //Setting to true so this will display when necessary for the above cases
}
